import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SpinLoading } from 'antd-mobile';

const HomePage = lazy(() => import('./pages/home'));
const NotFoundPage = lazy(() => import('@shared/pages/NotFound'));

const fallback = (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <SpinLoading color="primary" />
  </div>
);

export default function AppRouter() {
  return (
    <Suspense fallback={fallback}>
      <Routes>
        {/* 首页：产品介绍，全屏公开；根路径默认进首页 */}
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
